import { useEffect, useState } from "react";
import CompleteProfileDialog from "./CompleteProfileDialog";
import { usePWAPrompt, isIos, isInStandaloneMode } from "./usePWAPrompt";
import PopupDialog from "./popupdialog";


// --- Constants ---
const onboardingUrl = "https://cubble.notion.site/234bb0a475b4816eba3fe13fd141cfae?pvs=105";
const links = [
  { label: "📖 Read the Onboarding", url: onboardingUrl, desc: "Internship onboarding, rules & best practices.", color: "bg-blue-600 hover:bg-blue-500", external: true },
  { label: "💬 WhatsApp Group", url: "https://chat.whatsapp.com/Gmnbob1InkJEdHkPxYc4FA?mode=ac_t", desc: "Intern announcements & team chat.", color: "bg-green-600 hover:bg-green-500", external: true },
  { label: "📁 Google Drive", url: "https://drive.google.com/drive/u/1/folders/0AG_GvNdypzhTUk9PVA", desc: "Shared files & resources.", color: "bg-blue-700 hover:bg-blue-600", external: true },
  { label: "🔑 Request Access", url: "https://cubble.notion.site/234bb0a475b480a99d93d0dd9c248a64?pvs=105", desc: "Access to Notion, GitHub, etc.", color: "bg-yellow-600 hover:bg-yellow-500", external: true },
  { label: "🗓️ Weekly Update Form", url: "https://www.notion.so/cubble/23ebb0a475b480cbb00df38f0ff2220c?pvs=106", desc: "Log weekly progress.", color: "bg-purple-600 hover:bg-purple-500", external: true },
  { label: "📝 Feedback Form", url: "https://docs.google.com/forms/d/e/1FAIpQLSeJ5xQyq-N3IPl9D7bOOWvOnUww2u0n5kzd1OsR8pnFMGyfyw/viewform", desc: "Suggestions, ideas, feedback.", color: "bg-pink-600 hover:bg-pink-500", external: true },
  { label: "🛟 Support", url: "mailto:tech@cubble.com", desc: "Tech or HR help.", color: "bg-gray-800 hover:bg-gray-700", external: true }
];

export default function Links() {
  const [email, setEmail] = useState(null);
  const [userData, setUserData] = useState(null);
  const [emailMismatch, setEmailMismatch] = useState(false);
  const [showProfileDialog, setShowProfileDialog] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showIosBanner, setShowIosBanner] = useState(false);
  const { showPrompt, promptInstall } = usePWAPrompt();

  const [isAdmin, setIsAdmin] = useState(false);
  const [requireAdminAuth, setRequireAdminAuth] = useState(false);
  const [adminVerified, setAdminVerified] = useState(false);
  const [adminPassInput, setAdminPassInput] = useState("");

  const [showMembersView, setShowMembersView] = useState(false);
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    const emailFromStorage = localStorage.getItem("cubble-email");
    const alreadyVerified = localStorage.getItem("cubble-admin-verified");

    if (!emailFromStorage) return window.location.href = "/login";
    if (alreadyVerified === "yes") {
      setAdminVerified(true);
      setRequireAdminAuth(false);
    }

    fetch(`/api/profile-check?email=${encodeURIComponent(emailFromStorage)}`)
      .then(res => res.json())
      .then(data => {
        setEmail(emailFromStorage);
        setUserData(data);

        const isAdmin = data.admin === "yes";
        setIsAdmin(isAdmin);

        if (isAdmin && alreadyVerified !== "yes") {
          setRequireAdminAuth(true);
          return;
        }

        if (!isAdmin && (!data.name || !data.phone)) {
          setShowProfileDialog(true);
        }

        if (data.email && data.email !== emailFromStorage) {
          setEmailMismatch(true);
          fetch("/api/save-profiles", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: data.id,
              email: emailFromStorage,
              name: data.name,
              phone: data.phone,
            }),
          });
        }
      })
      .catch(err => {
        console.error("❌ Failed to load user profile:", err);
      });
  }, []);

   //  iOS “Add to Home Screen” banner
 useEffect(() => {
   if (isIos() && !isInStandaloneMode()) {
     setShowIosBanner(true);
   }
 }, []);

  useEffect(() => {
    if (showMembersView && isAdmin && adminVerified) {
      fetch("/api/all-users")
        .then(res => res.json())
        .then(data => setAllUsers(data.users || []))
        .catch(err => console.error("Failed to fetch users:", err));
    }
  }, [showMembersView, isAdmin, adminVerified]);

  const handleLogout = () => {
    localStorage.removeItem("cubble-email");
    localStorage.removeItem("cubble-admin-verified");
    window.location.href = "/login";
  };

  if (!email) {
    return <div className="flex h-screen items-center justify-center text-lg text-white">Checking authentication…</div>;
  }

  return (
    <div className="min-h-screen flex flex-col items-center px-2" style={{ background: "radial-gradient(ellipse at 30% 10%, #232a37 0%, #2a2443 55%, #512f60 80%)" }}>
      {/* 🔐 Profile Dialog */}
      <CompleteProfileDialog
        open={showProfileDialog}
        onClose={() => setShowProfileDialog(false)}
        userData={userData}
        emailMismatch={emailMismatch}
        onSubmit={(updated) => {
          fetch("/api/save-profiles", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...updated, id: userData.id }),
          }).then(() => setShowProfileDialog(false));
        }}
      />

      {/* POPUP ONBOARDING */}
      <PopupDialog open={showPopup} onClose={() => setShowPopup(false)} onboardingUrl={onboardingUrl} />

  
        

        {/* ---- INSTALL PROMPTS ---- */}
      {showPrompt && (
        <div className="w-full max-w-lg mb-3 rounded-xl bg-blue-950 border border-blue-900 px-4 py-3 flex items-center justify-between shadow">
          <span className="text-white font-semibold">
            📲 Install the Cubble Internship App for easy access!
          </span>
          <button
            onClick={promptInstall}
            className="ml-4 px-4 py-2 rounded-lg bg-blue-600 text-white font-bold hover:bg-blue-700"
          >
            Install
          </button>
        </div>
      )}
      {showIosBanner && (
        <div className="w-full max-w-lg mb-3 rounded-xl bg-yellow-900 border border-yellow-400 px-4 py-3 flex items-center shadow">
          <span className="text-yellow-200">
            📱 To install: Tap <b>Share</b> <span style={{fontSize:18}}>🔗</span> then <b>Add to Home Screen</b>
          </span>
          <button
            onClick={() => setShowIosBanner(false)}
            style={{marginLeft:12, fontWeight:700, color:"#fff", border:"none", background:"none", fontSize:22, cursor:"pointer"}}
            aria-label="Dismiss"
          >×</button>
        </div>
      )}

      
      {/* 🔐 Admin Password Dialog */}
      {requireAdminAuth && !adminVerified && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 1000, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div style={{ background: "#1e2235", padding: 30, borderRadius: 16, width: 350 }}>
            <h2 style={{ fontSize: 18, color: "#fff", marginBottom: 16 }}>🔐 Admin Verification</h2>
            <input
              type="password"
              placeholder="Enter admin password"
              value={adminPassInput}
              onChange={e => setAdminPassInput(e.target.value)}
              style={{ width: "100%", padding: 10, borderRadius: 6, background: "#2a2f45", border: "1px solid #3b4060", color: "#fff" }}
            />
            <div style={{ marginTop: 14, display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={() => {
                  if (adminPassInput === userData.password) {
                    setAdminVerified(true);
                    setRequireAdminAuth(false);
                    localStorage.setItem("cubble-admin-verified", "yes");
                  } else {
                    alert("❌ Incorrect password");
                  }
                }}
                style={{ padding: "10px 16px", background: "#3b82f6", color: "#fff", fontWeight: "bold", border: "none", borderRadius: 6 }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="w-full max-w-lg mt-10 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-3xl font-extrabold text-white tracking-tight">Internship Portal</div>
            <div className="text-sm text-white font-semibold tracking-wide">by Cubble</div>
          </div>
          <button
            onClick={handleLogout}
            className="ml-2 py-2 px-4 rounded-lg font-semibold hover:bg-red-900 hover:text-white transition"
            style={{ background: "rgba(220,38,38,0.18)", color: "#ef4444" }}
          >
            Logout
          </button>
        </div>
        <div className="text-xs text-gray-300 mt-1">Welcome, <b className="text-white">{email}</b></div>
      </div>

      {/* Admin-only button */}
      {isAdmin && adminVerified && !showMembersView && (
        <button
          onClick={() => setShowMembersView(true)}
          className="mt-4 mb-4 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold px-5 py-2 rounded-lg"
        >
          👥 View Members
        </button>
      )}

      {/* Members View */}
      {showMembersView ? (
        <div className="w-full max-w-lg mt-6 bg-gray-900 p-6 rounded-xl text-white shadow-2xl border border-gray-700">
          <div className="flex justify-between items-center mb-4">
            <div className="text-xl font-bold">All Members</div>
            <button
              onClick={() => setShowMembersView(false)}
              className="text-sm bg-gray-700 hover:bg-gray-600 text-white font-semibold px-3 py-1 rounded-lg"
            >
              🔙 Back
            </button>
          </div>
          {allUsers.length === 0 ? (
            <div>No members found.</div>
          ) : (
            <ul className="space-y-3">
              {allUsers.map(user => (
                <li key={user.id} className="flex justify-between items-center border-b border-gray-700 pb-2">
                  <div>
                    <div className="font-medium">{user.name}</div>
                    <div className="text-sm text-gray-400">{user.email} | {user.phone}</div>
                  </div>
                  <button
                    onClick={async () => {
                      await fetch("/api/remove-user", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: user.id })
                      });
                      setAllUsers(allUsers.filter(u => u.id !== user.id));
                    }}
                    className="text-red-400 hover:text-red-300 text-sm font-semibold"
                  >
                    Remove
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      ) : (
        // Regular Link Grid
        <div className="flex flex-col w-full max-w-lg gap-5 mt-6">
          {links.map((item, idx) => (
            <a
              key={idx}
              href={item.url}
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noopener noreferrer" : undefined}
              className={`flex flex-col shadow-2xl rounded-2xl ${item.color} py-5 px-6 transition transform hover:scale-[1.01]`}
              onClick={item.label === "📖 Read the Onboarding" ? (e) => { e.preventDefault(); setShowPopup(true); } : undefined}
            >
              <span className="font-bold text-xl mb-1 text-white">{item.label}</span>
              <span className="text-base font-medium text-gray-100 opacity-90">{item.desc}</span>
            </a>
          ))}
        </div>
      )}

      <footer className="w-full max-w-lg text-center text-xs text-gray-500 mt-12 mb-6">
        Internship Portal &copy; {new Date().getFullYear()} | Cubble
      </footer>
    </div>
  );
}
